export default __webpack_public_path__ + "static/media/search-icon-grey.63db515b.svg";